import { template as template_578c53958c5e404e8701a4064e2728b2 } from "@ember/template-compiler";
import { buildApproachFacetOptions } from 'client-portal/utils/clinicianSearch/approach-facet-options';
import { facetOptionDisabled } from 'client-portal/utils/clinicianSearch/facet-catalog';
import { fn } from '@ember/helper';
import { parseTrimmedString } from 'client-portal/utils/clinicianSearch/comma-query-param';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import RequestClinicianSearchFiltersFilterRadioLine from '../filters/filter-radio-line';
import RequestClinicianSearchFiltersPanel from '../filters/panel';
import styles from './approaches.module.scss';
import t from 'ember-intl/helpers/t';
const RADIO_NAME = 'clinician-search-approaches-filter';
export default class RequestClinicianSearchFacetFiltersApproaches extends Component {
    @service
    intl;
    @service
    clinicianSearch;
    radioName = RADIO_NAME;
    @tracked
    options = [];
    @tracked
    loadFailed = false;
    @tracked
    isLoadingOptions = true;
    get selectedApproach() {
        return parseTrimmedString(this.clinicianSearch.query.approaches);
    }
    get panelLoading() {
        return this.isLoadingOptions || this.clinicianSearch.sendAll.isLoading;
    }
    get loadingAriaLabel() {
        if (this.clinicianSearch.sendAll.isLoading) {
            return this.intl.t('booking.clinicianSearch.filterDetail.filterOptionsLoading');
        }
        return this.intl.t('booking.clinicianSearch.filterDetail.approachesOptionsLoading');
    }
    refreshOptions = ()=>{
        this.loadFailed = false;
        this.isLoadingOptions = true;
        try {
            let routeParams = {
                ...this.clinicianSearch.query.toRouteParams(),
                service: null
            };
            let meta = this.clinicianSearch.sendAll.buildFacetsMeta(routeParams);
            this.options = buildApproachFacetOptions(this.clinicianSearch.sendAll.records, meta?.facets?.approaches ?? []);
        } catch  {
            this.loadFailed = true;
            this.options = [];
        } finally{
            this.isLoadingOptions = false;
        }
    };
    isOptionSelected = (option)=>this.selectedApproach.toLowerCase() === String(option.key ?? '').toLowerCase();
    optionDisabled = (option)=>facetOptionDisabled(option.docCount, this.isOptionSelected(option));
    optionRowTitle = (option)=>{
        if (!this.optionDisabled(option)) {
            return '';
        }
        return this.intl.t('booking.clinicianSearch.filterDetail.disabledFilterOption');
    };
    selectApproach = (option, event)=>{
        if (!event.target.checked || !option.key) {
            return;
        }
        this.clinicianSearch.query.applyFacetFilter('approaches', option.key);
        this.clinicianSearch.mobile.backFromDetail();
    };
    static{
        template_578c53958c5e404e8701a4064e2728b2(`
    <RequestClinicianSearchFiltersPanel
      @hideApply={{true}}
      @class={{styles.component}}
      class="clinician-search-filter-approaches-options"
      @facetKey="approaches"
      @isLoading={{this.panelLoading}}
      @loadingAriaLabel={{this.loadingAriaLabel}}
      @onLoad={{this.refreshOptions}}
      data-test-clinician-search-filter-approaches-options
    >
      <p class="filter-section-title" id="clinician-search-approaches-filter-title">{{t
          "booking.clinicianSearch.filterDetail.approachesFilterPanelTitle"
        }}</p>
      {{#if this.loadFailed}}
        <p class="error" data-test-clinician-search-filter-approaches-options-error>
          {{t "booking.clinicianSearch.filterDetail.approachesLoadError"}}
        </p>
      {{/if}}
      <div class="body" role="group" aria-labelledby="clinician-search-approaches-filter-title">
        <ul class="filter-checkbox-list" role="list">
          {{#each this.options as |option|}}
            <RequestClinicianSearchFiltersFilterRadioLine
              @kind="approaches"
              @optionId={{option.slug}}
              @docCount={{option.docCount}}
              @name={{this.radioName}}
              @value={{option.key}}
              @checked={{this.isOptionSelected option}}
              @disabled={{this.optionDisabled option}}
              @title={{this.optionRowTitle option}}
              @onChange={{fn this.selectApproach option}}
            >
              {{option.label}}
            </RequestClinicianSearchFiltersFilterRadioLine>
          {{/each}}
        </ul>
      </div>
    </RequestClinicianSearchFiltersPanel>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
